<section class="first-section">
  <div class="text">
    <h2 class="third">Capacitación en Desarrollo de Software Comercial (DEV)</h2>
    <div class="fourth">
      <p class="text1">Postula a nuestro programa de capacitación en Desarrollo de Software Comercial</p>
      <p class="text2">-100% Remoto</p>
      <p class="text2">-Gratuito</p>
      <p class="text2">-Con trabajo asegurado</p>
    </div>
  </div>
</section>
<div>
  <app-introduction></app-introduction>
  <app-jalasoft-foundation></app-jalasoft-foundation>
  <app-intro-benefits></app-intro-benefits>
  <app-intro-options></app-intro-options>
  <div class="skills-sections">
    <app-skills-invitation></app-skills-invitation>
    <app-skills-dates></app-skills-dates>
    <app-skills-requirement></app-skills-requirement>
  </div>
</div>
